import DashboardRoutes from "../routes/DashboardRoutes";
import CompaniesRoutes from "../routes/CompaniesRoutes";
import AccountRoutes from "../routes/AccountRoutes";
import OtherRoutes from "../routes/OtherRoutes";
import POSRoutes from "../routes/POSRoutes";
import ProductRoutes from "../routes/ProductRoutes";
import TemplateRoutes from "../routes/TemplateRoutes";
import CustomerOrdersRoutes from "../routes/CustomerOrdersRoutes";
import StockRoutes from "../routes/StockRoutes";
import PricesRoutes from "../routes/PricesRoutes";
import StoresRoutes from "../routes/StoresRoutes";
import SupplierOrdersRoutes from "../routes/SupplierOrdersRoutes";

export const AllRoutes = [
    ...OtherRoutes,
    ...TemplateRoutes,
    ...DashboardRoutes,
    ...CompaniesRoutes,
    ...AccountRoutes,
    ...POSRoutes,
    ...ProductRoutes,
    ...CustomerOrdersRoutes,
    ...StockRoutes,
    ...PricesRoutes,
    ...StoresRoutes,
    ...SupplierOrdersRoutes
];
